import { RecipeVariantProps, sva } from "styled-system/css";

export const staffCard = sva({
  slots: ["root"],
  variants: {
    visual: {
      invited: {
        root: {
          backgroundColor: "cream.100",
          borderStyle: "dashed",
        },
      },
      accepted: {
        root: {
          backgroundColor: "white",
          borderStyle: "solid",
        },
      },
    },
  },
  defaultVariants: {
    visual: "accepted",
  },
});

export type StaffCardVariants = RecipeVariantProps<typeof staffCard>;
